
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/tools/feeds/create",
      function () {
        return require("private-next-pages/[locale]/tools/feeds/create/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/tools/feeds/create"])
      });
    }
  